import { Map } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';

interface MapViewToggleProps {
  showMap: boolean;
  onToggleMap: (show: boolean) => void;
}

export function MapViewToggle({ showMap, onToggleMap }: MapViewToggleProps) {
  return (
    <div className="flex items-center gap-2">
      <Switch id="map-toggle" checked={showMap} onCheckedChange={onToggleMap} />
      <Label
        htmlFor="map-toggle"
        className="flex cursor-pointer items-center gap-1.5"
      >
        <Map className="h-4 w-4" />
        <span className="hidden sm:inline">Map</span>
      </Label>
    </div>
  );
}
